import { fork } from 'typed-redux-saga';

import getNetworkSaga from './getNetwork';

export default function* networkSagas() {
  yield fork(getNetworkSaga);
}
